<template>
  <page class="stakeoutshipment-app">
    <nav-bar slot="header"></nav-bar>
    <page-content slot="content">
      <page-bar v-if="isPrint">
        <page-bar-item :label="$route.meta.label"></page-bar-item>
      </page-bar>
      <portlet class="form-query" hide-title="true">
        <slot name="title"></slot>
        <base-title v-if="isPrint" title="当前自评表"></base-title>
        <el-row style="margin-bottom: 20px;">
          <el-col :span="24">
            <el-col :span="6">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEva.evaluationNo"
                label="自评表编号"
              ></base-string>
            </el-col>
            <el-col :span="6">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEva.evaluationName"
                label="自评表名称"
              ></base-string>
            </el-col>
            <el-col :span="6">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="category"
                label="类别"
              ></base-string>
            </el-col>
            <el-col :span="6">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.brandCode"
                label="品牌"
              ></base-string>
            </el-col>
            <el-col :span="6">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.vendorName"
                label="供应商"
              ></base-string>
            </el-col>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="24">
            <base-string
              v-model="source.TODO"
              :disabled="true"
              :read-only="true"
              :rows="4"
              type="textarea"
              label="审核意见"
            ></base-string>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.developNo"
                label="面料组别"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.relatedMaterialCode"
                label="面料编号"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.developDesc"
                label="面料名称"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.ingredient"
                label="成份"
              ></base-string>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.sealingWidth"
                label="门幅:边到边"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.actSealingWidth"
                label="实用"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.standardCode"
                label="规格"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.yarn"
                label="纱织"
              ></base-string>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.weight"
                label="克 重:注1"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.fabricArea"
                label="原材料产地"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.wearDate"
                label="大货货期"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.wearMoq"
                label="大货起定量"
              ></base-string>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.wearPrice"
                label="大货价格"
              ></base-string>
          </el-col>
          <el-col :span="12">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.cottonYarn"
                label="精梳/粗疏/半精梳"
              ></base-string>
          </el-col>
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.selfEvaAttrs.vendorMaterialCode"
                label="供应商物料编号"
              ></base-string>
          </el-col>
        </el-row>
        <el-row v-if="source.TODO">
          <el-col :span="6">
            <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.materialCode"
                label="关联款号/款名"
              ></base-string>
          </el-col>
        </el-row>

        <div class="selfevaluation-check__list">
          <div class="selfevaluation-check__list-item">
            <p>此面料：</p>
            <base-checkbox
              :multiple="true"
              :read-only="true"
              :options="globalEnum.technicList"
              v-model="source.technic"
            ></base-checkbox>
          </div>
          <div class="selfevaluation-check__list-item">
            <p>此面料不可承担之成衣加工工艺及洗涤方法：</p>
            <base-checkbox
              :multiple="true"
              :read-only="true"
              :options="globalEnum.washTechnicList"
              v-model="source.washTechnic"
            ></base-checkbox>
          </div>
          <div class="selfevaluation-check__list-item">
            <p>在生产成衣过程中可能发生之质量问题/风险：</p>
            <el-row>
              <el-col :span="24">
                <template>
                  <base-string :read-only="true" v-model="source.selfEva.risk" label :style-type="2"></base-string>
                </template>
              </el-col>
            </el-row>
          </div>
          <div class="selfevaluation-check__list-item">
            <p>建议洗涤方式：</p>
            <el-row>
              <el-col :span="24">
                <template>
                  <base-string :read-only="true" v-model="source.selfEva.washingMethod" label :style-type="2"></base-string>
                </template>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-row type="flex" style="margin-bottom: 40px;">
          <el-table :data="source.selfEva.itemList" border style="margin-top: 10px" stripe>
            <el-table-column
              :show-overflow-tooltip="true"
              property="nationalInspectionName"
              label="国家检验项目"
              :min-width="200"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="inspectionCategory"
              label="检验类"
              :min-width="70"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="inspection"
              label="是否必填"
              :min-width="80"
            >
              <template scope="scope">
                <base-select
                  style-type="2"
                  :read-only="true"
                  :label-width="0"
                  v-model="scope.row.inspection"
                  apiName="POST_SPS_SYS_ENUM_URL"
                  :params="{typeCode: 'IsNeedOrNot'}"
                  placeholder
                ></base-select>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="firstStandard"
              label="一等品标准"
              :min-width="200"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="productStandard"
              label="合格品标准"
              :min-width="200"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="inspectionExplain"
              label="检验说明"
              :min-width="100"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="conformType"
              label="是否符合"
              :min-width="100"
            >
            <template scope="scope">
              {{scope.row.conformType ? conformTypeMap[scope.row.conformType] : ''}}
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="selfAchievableDegree"
              label="供应商自估可达到程度"
              :min-width="150"
            >
            </el-table-column>
          </el-table>
        </el-row>
        <el-row v-for="(item, idx) in flowLogList" :key="idx" style="margin-bottom: 20px">
          <el-row>{{item.auditNode}}意见</el-row>
          <el-row>
            <el-col :span="6">
              <base-string :read-only="true" v-model="item.auditStatusText" label="审核状态" :style-type="2"></base-string>
            </el-col>
            <el-col :span="6">
              <base-string :read-only="true" v-model="item.auditComment" label="审核意见" :style-type="2"></base-string>
            </el-col>
            <el-col :span="6">
              <base-string :read-only="true" v-model="item.auditName" label="审核人" :style-type="2"></base-string>
            </el-col>
            <el-col :span="6">
              <base-string :read-only="true" v-model="item.auditTime" label="审核时间" :style-type="2"></base-string>
            </el-col>
          </el-row>
        </el-row>
      </portlet>
    </page-content>
  </page>
</template>
<script>
import baseString from "components/base-control/modules/base-string.vue";
import baseCheckbox from "components/base-control/modules/base-checkbox.vue";
import baseSelect from "components/base-control/modules/base-select.vue";
import * as globalEnum from "src/common/global-enum";
import * as utils from "@/store/utils";
// import { parseImgUrlProductImg } from "src/filter/modules/img";
export default {
  name: "selfevaluation-check",
  props: {
    type: {
      type: [String, Number],
      default: 1
    },
    isPrint: {
      type: Boolean,
      default: false
    }
  },
  components: {
    baseString,
    baseCheckbox,
    baseSelect
  },
  filters: {
    // parseImgUrlProductImg
  },
  computed: {
  },
  methods: {
    FABRIC_QUOTED_GET() {
      this.$apis.autoAPi
        .FABRIC_QUOTED_GET({
          id: this.$route.query.id
        })
        .done(res => {
          let washTechnic = formatWashTechnic(
            globalEnum.washTechnicList,
            res.data.selfEva.washTechnicList
          );
          let technic = formatWashTechnic(
            globalEnum.technicList,
            res.data.selfEva.technicList
          );
          let brandCode = ''
          if(res.data.selfEva.brandCodeList) {
            res.data.selfEva.brandCodeList.forEach(brand => {
              brandCode += this.brandToName[brand] + ','
            });
          }
          this.source = {
            ...res.data,
            washTechnic: washTechnic,
            technic: technic,
            brandCode
          };
          function formatWashTechnic(keyList, array) {
            return keyList.reduce((pre, next) => {
              const i = array.findIndex(item => item == next.code);
              if (i > -1) pre.push(next.comment);
              return pre;
            }, []);
          }
          this.flowLogList = res.data.flowLogList.map(item => {
            return {
              ...item,
              auditStatusText: this.auditMap[item.auditStatus],
              auditTime: item.updatedTime ? utils.formatTime(new Date(item.updatedTime)) : ''
            }
          })
        })
        .fail(err => {});
    },
  },
  mounted() {
    // if (!this.isPrint) {
    this.FABRIC_QUOTED_GET();
    // }
  },
  data() {
    return {
      list: [],
      globalEnum,
      source: {
        washTechnic: ['普洗'],
        technic: [],
        selfEva: {
        },
        selfEvaAttrs: {},
      },
      inputConfig: {
        readOnly: true
      },
      brandToName: {
        '1': 'OCH',
        '2': 'FP',
        '3': 'TRE',
        '6': 'M60',
        'C': 'CG',
        'U': 'DH'
      },
      flowLogList: [],
      auditMap: {
        0: '通过',
        1: '驳回',
        2: '归档'
      },
      category: '面料',
      conformTypeMap: {
        1: '符合(一等品)',
        2: '符合(合格品)',
        3: '不符合',
      }
    };
  }
};
</script>

<style scoped lang="scss">
.selfevaluation-check__list-item {
  margin-bottom: 10px;
}
.selfevaluation-check__img {
  border: 1px solid #ddd;
  img {
    max-width: 300px;
    max-height: 400px;
  }
}
</style>
